//region block: pre-declaration
//endregion
function reflectAnnotation(annotation) {
  return null;
}
//region block: exports
export {
  reflectAnnotation as reflectAnnotation3vd82vtja4yiy,
};
//endregion

//# sourceMappingURL=SerializationHacks.nonJvm.mjs.map
